import { configureStore } from '@reduxjs/toolkit'
import { slice as activeSlice } from './activeSlice'
import { slice as bshSlice } from './bshSlice'
import { slice as collapsedSlice } from './collapsedSlice'

const store = configureStore({
  reducer: {
    [activeSlice.name]: activeSlice.reducer,
    [bshSlice.name]: bshSlice.reducer,
    [collapsedSlice.name]: collapsedSlice.reducer,
  },
  devTools: true,
})

export * as activeSlice from './activeSlice'
export * as bshSlice from './bshSlice'
export * as collapsedSlice from './collapsedSlice'

export default store
